import ConfirmPath from './ConfirmPath'
export default ConfirmPath
